import { Image } from '#app/components/Image/Image.js';
import { Tag, type TagVariant } from '#app/components/Tags/Tag.js';
import { SocialUnidentifiedToolIcon } from '@contra/icons/icons';

export type Tool = {
  id: string;
  logoImage: null | { uid: string };
  name: string;
};

export type ToolsArray = readonly Tool[];

type ToolsListProps = {
  readonly readOnly?: boolean;
  readonly tools: ToolsArray;
  readonly variant?: TagVariant;
};

export const ToolsList = ({
  readOnly = false,
  tools,
  variant,
}: ToolsListProps) => {
  if (tools.length === 0) return null;

  return (
    <>
      {tools.map(({ id, logoImage, name }) => (
        <Tag
          icon={
            logoImage ? (
              <Image
                alt={`${name} icon`}
                height={24}
                uid={logoImage.uid}
                width={24}
              />
            ) : (
              <SocialUnidentifiedToolIcon />
            )
          }
          key={id}
          label={name}
          readOnly={readOnly}
          variant={variant}
        />
      ))}
    </>
  );
};
